module.exports = __webpack_public_path__ + "static/media/role.5fb1692e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/role.svg
// module id = 494
// module chunks = 0